import { createStyles } from 'core/utilities/theme';
import { conservationColor, conservationColorBgStyle } from 'sequenceAnalyser/utilities/colors';

export default createStyles({
  input: {
    width: '60px',
  },
  rail: {
    marginTop: '-3px',
    marginLeft: '1px',
    height: '10px',
    opacity: 1,
    borderRadius: '4px',
    background: `linear-gradient(to right, 
      ${conservationColorBgStyle(0)}, ${conservationColorBgStyle(10)},
      ${conservationColorBgStyle(10)}, ${conservationColorBgStyle(20)},
      ${conservationColorBgStyle(20)}, ${conservationColorBgStyle(30)},
      ${conservationColorBgStyle(30)}, ${conservationColorBgStyle(40)},
      ${conservationColorBgStyle(40)}, ${conservationColorBgStyle(50)},
      ${conservationColorBgStyle(50)}, ${conservationColorBgStyle(60)},
      ${conservationColorBgStyle(60)}, ${conservationColorBgStyle(70)},
      ${conservationColorBgStyle(70)}, ${conservationColorBgStyle(80)},
      ${conservationColorBgStyle(80)}, ${conservationColorBgStyle(90)},
      ${conservationColorBgStyle(90)}, ${conservationColorBgStyle(100)}
    )`,
  },
  track: {
    backgroundColor: `rgb(${conservationColor.join(',')})`,
    height: 0,
  },
  mark: {
    height: 0,
  },
  thumb: {
    backgroundColor: `rgb(${conservationColor.join(',')})`,
    border: '1px solid white',
    width: '18px',
    height: '18px',
    marginTop: '-4px',
  },
  valueLabel: {
    color: `rgb(${conservationColor.join(',')})`,
    left: 'calc(-50% + -1px)',
  },
});
